import { render, staticRenderFns } from "./FormLayoutMultipleColumn.vue?vue&type=template&id=9b370700&"
import script from "./FormLayoutMultipleColumn.vue?vue&type=script&lang=js&"
export * from "./FormLayoutMultipleColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports